export const generateProductModel = () => ({
  name: '',
  flags: [],
  state: 'Active',
  abbreviation: '',
});
